export const ROUTE_PATHS = {
  HOME: '/',
  CASH: '/cash',
  FIX_MY_CREDIT: '/fix-my-credit',
  REFERRAL: '/referral',
  REFERRAL_TERMS: '/referral-terms',
  BETTER: '/better',
  PRICING: '/pricing',
  ABOUT: '/about',
  PRIVACY: '/privacy',

  // Authentication
  AUTHENTICATE: '/authenticate',
  LOGIN: '/sign-in',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  MAGIC_LINK_SENT: '/magic-link-sent',
  MAGIC_LINK: '/magic-link',
  MAGIC_LINK_SHORT: '/m/:token',

  // TODO: Check verified and verify

  // Onboarding
  ONBOARDING: '/onboarding',
  TENANCY: '/onboarding/tenancy',
  ADDRESS: '/onboarding/address',
  INCOME: '/onboarding/income',
  LOAN_INTEREST: '/onboarding/loan-interest',
  REGISTER: '/onboarding/register',
  SUBSCRIPTION: '/onboarding/subscription',
  CONSENT: '/onboarding/consent',
  BUREAU_AUTH: '/onboarding/authorize',
  REVIEW_INFO: '/onboarding/verify',
  EDIT_INFO: '/onboarding/edit',
  FULL_SSN: '/onboarding/ssn',

  // B2C
  DASHBOARD: '/dashboard',
  RECOMMENDATION: '/dashboard/recommendation',
  ACCOUNT: '/dashboard/account',
  UPGRADE: '/dashboard/upgrade',
  MY_ACCOUNT: '/dashboard/account',
  MY_DEBTS: '/dashboard/debts',
  CREDIT_SCORE: '/dashboard/credit-score',
  REFERRAL_DASHBOARD: '/dashboard/referral',
  RENT_REPORTING: '/dashboard/rent-reporting',
  LOAN_APPLICATION: '/dashboard/loan-application',
  PLAID_OAUTH_RETURN: '/dashboard/plaid-oauth-return',
  CREDIT_BUILDER: '/dashboard/credit-builder',
  SHORT_TERM_LOAN: '/dashboard/short-term-loan',
  LOANS_MANAGEMENT: '/dashboard/loans',
  PAYMENT_LINK: '/dashboard/make-a-payment/:loanId',
  ACH_TERMS: '/ach-terms',
  LOAN_TERMS: '/loan-terms',

  // B2B
  LO_TOOL: '/mortgage-qualification',

  // MISC
  SERVICE_UNAVAILABLE: '/service-unavailable',
  ONBOARDING_ERROR: '/registration-failed',
  UNHANDLED_ERROR: '/error',
  BUREAU_NOT_FOUND: '/onboarding/bureau-error',
  LOCKED_OUT: '/locked-out',
  IDENTIFICATION_VERIFICATION_ERROR: '/identification-verification-error',
  DOCUSIGN_REDIRECT: '/docusign-redirect',
};

export const BASE_ROUTE_PATHS = {
  DASHBOARD: '/dashboard',
  ONBOARDING: '/onboarding',
};
